import { useEffect } from "react";

type MetaInput = {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
};

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta(meta: MetaInput) {
  useEffect(() => {
    document.title = meta.title;
    upsertMeta("name", "description", meta.description);
    upsertMeta("name", "keywords", meta.keywords);
    upsertMeta("name", "robots", "index,follow");
    upsertMeta("property", "og:title", meta.ogTitle ?? meta.title);
    upsertMeta("property", "og:description", meta.ogDescription ?? meta.description);
    upsertMeta("property", "og:type", meta.ogType ?? "website");
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", meta.ogTitle ?? meta.title);
    upsertMeta("name", "twitter:description", meta.ogDescription ?? meta.description);

    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", meta.canonical);
  }, [meta]);
}